import { ScrollAnimation } from "./ScrollAnimation.js";
import { animationScrollWithEase } from "./animationScrollWithEase.js";
class ScrollAnimationWithEase extends animationScrollWithEase(ScrollAnimation) {
  /**
   * Config.
   */
  static config = {
    ...ScrollAnimation.config,
    name: "ScrollAnimationWithEase"
  };
}
export {
  ScrollAnimationWithEase
};
//# sourceMappingURL=ScrollAnimationWithEase.js.map
